import { NoteCategory } from '../../../coaching-base/general';
import { NoteDetailFormValue } from '../../../coaching-note/note-detail-form-value.model';
import { createNoteDetail } from '../../../coaching-note/note-detail.form';
import { User } from '../../../user/user.model';

export function createNote(text: string, user: User): NoteDetailFormValue {
    const note = createNoteDetail(NoteCategory.GENERAL);
    note.contents = text;
    note.noteId = 0;
    note.createdByFirstName = user.firstName;
    note.createdByLastName = user.lastName;
    note.updatedByFirstName = user.firstName;
    note.updatedByLastName = user.lastName;
    return note;
}
